"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseOkCV = exports.responseErrorCV = void 0;
const clarityValue_1 = require("../clarityValue");
function responseErrorCV(value) {
    return { type: clarityValue_1.ClarityType.ResponseErr, value };
}
exports.responseErrorCV = responseErrorCV;
function responseOkCV(value) {
    return { type: clarityValue_1.ClarityType.ResponseOk, value };
}
exports.responseOkCV = responseOkCV;
//# sourceMappingURL=responseCV.js.map